import { api } from "./api";
import { detectPlatform, loadMessengerSdk, waitForInitData } from "./platform";

export interface AuthUser {
  id: string;
  firstName: string | null;
  paidBalance: number;
  hasPhoto: boolean;
}

export async function authenticate(): Promise<AuthUser> {
  const platform = detectPlatform();
  if (platform === "browser") {
    throw new Error("Запусти приложение из бота — здесь нужна авторизация Telegram/Max");
  }

  await loadMessengerSdk();
  const wa = (window as any).Telegram?.WebApp || (window as any).WebApp;

  if (wa?.expand) wa.expand();

  // Полноэкранный режим без header'а Telegram — только для мобильных платформ
  // (на десктопе TG это даёт странный fullscreen на весь экран).
  if (wa?.requestFullscreen && ["ios", "android", "android_x"].includes(wa.platform)) {
    try {
      wa.requestFullscreen();
    } catch {}
  }
  // Отключить swipe-down для закрытия — чтобы юзер не закрывал TWA при скролле
  if (wa?.disableVerticalSwipes) {
    try {
      wa.disableVerticalSwipes();
    } catch {}
  }

  // Safe area для мобильного TWA — нужен padding сверху под header Telegram.
  // По паттерну из aikrab.com: тэг body.twa-mobile + явный 90px.
  // На десктопе/web этот класс не добавляется → отступа нет.
  const isMobileDevice = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  if (isMobileDevice) {
    document.body.classList.add("twa-mobile");
  }

  if (wa?.ready) wa.ready();

  const initData = await waitForInitData();
  if (!initData) throw new Error("Не получены данные инициализации от мессенджера");

  const { data } = await api.post("/auth/twa", { initData, platform });
  localStorage.setItem("snimok-token", data.token);
  return data.user;
}
